/* js/modal.js */

;(function ($, window, document) {

    $(document).on('ready', function () {

        initModal();

        function initModal() {
            var $openBtn = $('.maw-modal--button[data-id]'),
                $openBtnLink = $('.maw-modal--button[data-id] a'),
                $closeBtn = $('.maw-modal--close'),
                openCls = 'is--open';

            $openBtnLink.on('click', function (event) {
                event.preventDefault();
            });

            $openBtn.on('click', function () {
                var modalId = $(this).attr('data-id'),
                    modalIdSelector = '#' + modalId,
                    $otherModals = $('.maw-modal'),
                    $modal = $(modalIdSelector),
                    $modalVideo = $modal.find('.ce_vimeo');


                $otherModals.removeClass(openCls);
                $modal.addClass(openCls);

                /**
                 * Autoplay Vimeo on open modal
                 */

                if ($modalVideo.length && $modalVideo != undefined) {

                    var $iframe = $modalVideo.find('iframe').get(0),
                        $player = new Vimeo.Player($iframe);

                    $player.ready().then(function () {
                        $player.play();
                    });

                }

            });

            $closeBtn.on('click', function () {
                $(this).parent().removeClass(openCls);

                // Stop player
                var $frame = $(this).parent().find('iframe'),
                    vidsrc = $frame.attr('src');

                $frame.attr('src', '');
                $frame.attr('src', vidsrc);

            });
        }

        var $videoContainer = $('.dbd-videos');

        if ($videoContainer.length) {
            initVideoOverlayNavigation();
        }

        function initVideoOverlayNavigation() {

            var $overlay = $('.maw-modal:not(#maw-modal-termin-form)');

            $overlay.each(function (index) {
                $(this).attr('data-modal-index', index + 1);
            });

            appendNavigation();
            initModal();

            function appendNavigation() {
                var prev = '<button class="maw-modal--button modal-nav-button modal-nav-button--prev"></button>',
                    next = '<button class="maw-modal--button modal-nav-button modal-nav-button--next"></button>';

                $overlay.append(prev);
                $overlay.append(next);

                setNavigationTargets();
            }

            function setNavigationTargets() {

                var $prev = $('.modal-nav-button--prev'),
                    $next = $('.modal-nav-button--next');

                $prev.each(function () {

                    var modalIndex = parseInt($(this).parent().attr('data-modal-index')),
                        targetIndex = modalIndex - 1,
                        targetModal = $('body').find('*[data-modal-index="' + targetIndex + '"]'),
                        targetModalId = targetModal.attr('id');

                    if (targetModal.length) {
                        $(this).attr('data-id', targetModalId);
                    } else {
                        $(this).addClass('disabled');
                    }


                });

                $next.each(function () {

                    var modalIndex = parseInt($(this).parent().attr('data-modal-index')),
                        targetIndex = modalIndex + 1,
                        targetModal = $('body').find('*[data-modal-index="' + targetIndex + '"]'),
                        targetModalId = targetModal.attr('id');

                    if (targetModal.length) {
                        $(this).attr('data-id', targetModalId);
                    } else {
                        $(this).addClass('disabled');
                    }


                });

                $prev.on('click', function () {

                    var $frame = $(this).parent().find('iframe'),
                        vidsrc = $frame.attr('src');

                    $frame.attr('src', '');
                    $frame.attr('src', vidsrc);

                });

                $next.on('click', function () {

                    var $frame = $(this).parent().find('iframe'),
                        vidsrc = $frame.attr('src');

                    $frame.attr('src', '');
                    $frame.attr('src', vidsrc);

                });

            }

        }

    });

})(jQuery, window, document);